import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import urls, { relativeUrl } from '@/constants/urls';

const AdminCollectionMenu = ({ allowNewCollections, allowCollections, url }) => (
  <>
    { allowNewCollections && (
      <Dropdown.Item
        as="a"
        href={url}
        selected={false}
      >
        <Icon name="plus" className="primary" />
        <FormattedMessage id="collection.header.menu.new" />
      </Dropdown.Item>
    )}
    { allowCollections && (
      <Dropdown.Item
        as="a"
        href={`#${relativeUrl(urls.COLLECTIONS)}`}
        selected={false}
      >
        <Icon name="object group outline" className="primary" />
        <FormattedMessage id="admin.header.menu.collections" />
      </Dropdown.Item>
    )}
  </>
);

export default AdminCollectionMenu;
